
import { createBrowserHistory } from 'history'

// provide a centralized history object
export const history = createBrowserHistory()
